import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCul = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M845 611q18-20 25-46 6-23 5-55-1-31-18-67-20-42-55-69-42-32-97-33-35 0-67 28-11 10-24 28-18 25-25 45-8 27 6 43 6 6 17 4t16.5-8.5 6-3-3 9-10 10T605 504q-13 3-23-1-13-5-19-21-4-11 0-29.5t16-35.5q16-23 46-49 4-3 4-7.5t-2-8.5q-15-21-45-37-39-22-87-22-80 0-150 84l-2 3q-9 9-18 26-11 21-15 38-4 22 5 33.5t22 9.5q8-2 14-7 7-6 7-4 1 9-15 22-5 4-15 6-12 2-22-1-12-5-17.5-18t-2-33 13.5-38q8-14 40-47l4-5q5-5 4-12t-8-10q-11-5-24-6-10-1-20 1l-24 5q-19 5-37 14-26 11-46 28-26 20-41 47-19 32-23 72-2 23 6 50 8 30 26 51 36 43 111 55h3l5 3q77 47 191.5 47T658 675l3-1q1 0 11-1 54-2 90-13 34-10 58-28l8-7q12-9 17-14z" })
});
export default SvgCul;
